import { render, staticRenderFns } from "./save_goods_list.vue?vue&type=template&id=1d328cda&scoped=true"
import script from "./save_goods_list.vue?vue&type=script&lang=js"
export * from "./save_goods_list.vue?vue&type=script&lang=js"
import style0 from "./save_goods_list.vue?vue&type=style&index=0&id=1d328cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d328cda",
  null
  
)

export default component.exports